export const formatoComun = {};

export const etiquetaTipo = (tipo) => {
  return tipo ? String(tipo).toUpperCase() : "DESCONOCIDO";
};

export const fmtNumero = (numero) => {
  return Number(numero || 0).toLocaleString("es-CO");
};

export const fmtFecha = (fecha) => {
  if (!fecha) return "-";
  try {
    return new Date(fecha).toLocaleDateString("es-CO");
  } catch (e) {
    return fecha;
  }
};

export default formatoComun;